/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const EmailNotification16 = (props: SVGProps) => (
    <AccessibleSVG width={16} height={16} viewBox="0 0 16 16" {...props}>
        <path
            fill={vars.bdlGray50}
            fillRule="evenodd"
            d="M1.205 3.646l6.56 6.024a.345.345 0 00.47 0l1.221-1.122 4.333 4.416a1.413 1.413 0 01-.189.012H2.4c-.065 0-.128-.004-.19-.013l4.333-4.415-.52-.478-4.507 4.592A1.397 1.397 0 011 11.576v-7.2c0-.267.075-.517.205-.73zm13.796 1.646L15 11.576c0 .438-.2.828-.515 1.085L9.977 8.07l3.025-2.777c.306.133.643.207.998.207.356 0 .694-.074 1-.208zm-3.479-1.959c.083.626.399 1.18.857 1.57l-4.38 4.021-6.087-5.59 9.61-.001zM14 1a2 2 0 110 4 2 2 0 010-4z"
        />
    </AccessibleSVG>
);

export default EmailNotification16;
